import { Command } from './Command';
import { EditFloorShapeAction } from '../actions';
import { RailingGenerationService } from '../../railing/services/railing-generation.service';
import { BuildFloorService } from '../../build-floor.service';
import { StageService } from '../../stage.service';

export class EditFloorShapeCommand extends Command<EditFloorShapeAction> {

  private oldPoints: Array<any>;
  private floorId: string;

  constructor(
    private railingGeneration: RailingGenerationService,
    private buildFloorSrvc: BuildFloorService,
    private stageSrvc: StageService
  ) {
    super();
  }

  do(action: EditFloorShapeAction) {
    this.oldPoints = action.oldPoints;
    const newFloor = this.buildFloorSrvc.buildFloor({ points: action.newPoints }, action.floorId);
    this.floorId = newFloor.userData.customId;
    this.railingGeneration.buildRailing(this.railingGeneration.IsVisible());
  }

  undo() {
    const result = this.stageSrvc.getChildrenByPredicate(obj => obj.userData.customId === this.floorId);
    this.buildFloorSrvc.buildFloor({ points: this.oldPoints }, result[0].id);
    this.railingGeneration.buildRailing(this.railingGeneration.IsVisible());
  }

}



// WEBPACK FOOTER //
// ./src/app/services/eventLog/commands/EditFloorShapeCommand.ts